module.exports = __webpack_public_path__ + "static/media/projectsImage7.b8876c10.jpg";